
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/transport",
      function () {
        return require("private-next-pages/business/transport/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/transport"])
      });
    }
  